import { useEffect } from 'react';
import { useToastContext } from '../contexts/ToastContext';
import { Toast } from './Toast';
import { setToastContext } from '../hooks/useToast';

export const ToastContainer = () => {
  const context = useToastContext();

  // Initialize global toast instance
  useEffect(() => {
    setToastContext(context);
  }, [context]);

  return (
    <div
      aria-live="assertive"
      className="pointer-events-none fixed inset-0 flex items-end px-4 py-6 sm:items-start sm:p-6 z-50"
    >
      <div className="flex w-full flex-col items-center space-y-4 sm:items-end">
        {context.toasts.map((toast) => (
          <Toast key={toast.id} toast={toast} />
        ))}
      </div>
    </div>
  );
};

